import React, { useRef, useState, useEffect } from "react";
import Layout from "../Common/Layout";
import { Link } from "react-router-dom";
import axios from "axios";

const CRD = () => {
  const [trucks, setTrucks] = useState([]);
  const orderprocess = JSON.parse(sessionStorage.getItem("orderprocess"));
 
  const sessionDate = orderprocess.order_date || "";
  const [totalBags, setTotalBags] = useState(0);

  const [client, setClient] = useState();

  const token = sessionStorage.getItem("token");


  const fetchClient = async () => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/master-client/client/by-crd/${orderprocess?.crdNo}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // Save API response in state
      setClient(res.data.data);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (orderprocess?.crdNo) {
      fetchClient();
    }
  }, [orderprocess?.crdNo]);

  const fetchKataSlipBags = async (crdNo) => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/kataslip/kataslip/crd/${crdNo}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // 🔹 support both formats
      const slips = res.data?.data || res.data || [];

      console.log("KataSlip Records:", slips);

      // 🔥 SUM noOfBags
      const sumBags = slips.reduce(
        (total, item) => total + Number(item.noOfBags || 0),
        0,
      );

      // 🔥 SUM net weight
      const sumNetWeight = slips.reduce(
        (total, item) => total + Number(item.netWt || 0),
        0,
      );

      const stackNumber = slips[0]?.stack || ""; // <-- pick first slip's stackNo

      console.log(stackNumber);

      const netWeightRounded = sumNetWeight.toFixed(2);

      // ✅ Store totals
      setTotalBags(sumBags);

      // ✅ Store truck list (for table)
      setTrucks(slips);

      // ✅ Update form
      setFormData((prev) => ({
        ...prev,
        NoofBags: sumBags,
        Quantity: netWeightRounded,
        Stack: stackNumber,
      }));
    } catch (error) {
      console.error("Error fetching kataslip:", error);
    }
  };

  useEffect(() => {
    if (orderprocess?.crdNo) {
      fetchKataSlipBags(orderprocess.crdNo);
    }
  }, [orderprocess?.crdNo]);

  console.log(client);

  const formRef = useRef();
  const [formdata, setFormData] = useState({
    crdNo: "",
    Date: sessionDate,
    WarehouseName: "",
    WarehouseAddress: "",
    LocationName: "",
    ClientName: "",
    ClientAddress: "",
    NameofCommodity: "",
    Variety: "",
    NoofBags: totalBags,
    Quantity: "",
    Stack: "",
    Rate: "",
    PackingQuality: orderprocess.quality_grade,
    PrivateID: "",
    Remarks: "",
  });

 
  // Fetch ID from sessionStorage

  console.log(client?.company_name);

  const safe = (v) => v ?? "";

  useEffect(() => {
    if (client) {
      setFormData((prev) => ({
        ...prev,

        // ✅ MATCH STATE KEYS EXACTLY
        ClientName: safe(client.company_name),
        ClientAddress: safe(client.address),
        NameofCommodity: safe(client.product),
        Variety: safe(client.variety),
        WarehouseName: safe(client.warehouse),
        WarehouseAddress: safe(client.warehouse_address), // ✅ ADD THIS

        Remarks: safe(client.remarks),
        crdNo: safe(client.crdNo),
      }));
    }
  }, [client]);

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.id]: e.target.value });
  };

  const handlePrint = async () => {
    try {
      // 🔹 Prepare payload for API (map frontend → backend fields)
      const payload = {
        crdNo: formdata.crdNo,
        receiptDate: formdata.Date,
        warehouseName: formdata.WarehouseName,
        locationName: formdata.LocationName,
        warehouseAddress: formdata.WarehouseAddress,
        clientName: formdata.ClientName,
        clientAddress: formdata.ClientAddress,
        commodityName: formdata.NameofCommodity,
        variety: formdata.Variety,
        noOfBags: formdata.NoofBags,
        quantityMT: formdata.Quantity,
        stackNo: formdata.Stack,
        ratePerMT: formdata.Rate,
        packingQuality: formdata.PackingQuality,
        privateIdMark: formdata.PrivateID,
        remarks: formdata.Remarks,

        truckDetails: trucks.map((t) => ({
          truckNo: t.vehicleNo,
          netWeight: t.netWt,
          noOfBags: t.noOfBags,
        })),
      };

      // 🔹 Save CRD data
      const token = sessionStorage.getItem("token"); // or sessionStorage

      await axios.post(
        "https://irc.zentelex.com/api/commodity-receipts",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      // 🔹 Print after successful save
      const printContents = formRef.current.innerHTML;
      const printWindow = window.open("", "_blank", "width=900,height=650");

      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print CRD</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            table { width: 100%; border-collapse: collapse; }
            table td, table th { border: 1px solid #000; padding: 6px; }
            h2, h3 { text-align: center; }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();

      sessionStorage.removeItem("orderprocess");
    } catch (error) {
      console.error("Error saving CRD:", error);
      alert("Failed to save CRD data");
    }
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div className="text-center mt-4">
                      <Link
                        style={{ color: "white", marginTop: "1rem" }}
                        to="/dashboard"
                        className="btn btn-primary"
                      >
                        Dashboard
                      </Link>
                    </div>
                    <div className="card-body p-4">
                      <div
                        ref={formRef}
                        style={{ padding: "20px", fontFamily: "Arial" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            padding: "15px 10px",
                            fontFamily: "Arial, Helvetica, sans-serif",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "32px",
                              fontWeight: "bold",
                              letterSpacing: "1px",
                            }}
                          >
                            IRC LIMITED
                          </div>

                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              marginTop: "5px",
                            }}
                          >
                            IRC HOUSE, 1 SUNYAT SEN STREET , KOLKATA-700012
                          </div>

                          <div
                            style={{
                              fontSize: "18px",
                              marginTop: "8px",
                            }}
                          >
                            TELEPHONE NO. : +91-33-2236-5110 (5 Lines) FAX:
                            +91-33-2225 5936, Email : ho@ircl.in
                          </div>

                          <div
                            style={{
                              fontSize: "18px",
                              marginTop: "5px",
                            }}
                          >
                            PAN NO : AACCP2218A &nbsp;&nbsp;&nbsp; TAN:
                            CALP02108B &nbsp;&nbsp;&nbsp; GSTIN: 19AACCP2218A1ZY
                          </div>
                        </div>
                        <h2
                          style={{
                            textAlign: "center",
                            marginBottom: "10px",
                            textTransform: "uppercase",
                          }}
                        >
                          Commodity Receipt Document
                        </h2>

                        <div>
                          <form>
                            {/* Example: Serial No & Date */}
                            <table
                              style={{ width: "100%", marginBottom: "15px" }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>CRD No.</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="SerialNo"
                                      value={formdata.crdNo}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <strong>Date</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="date"
                                      id="Date"
                                      value={formdata.Date}
                                      onChange={handleChange}
                                      className="form-control"
                                      
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Warehouse Details */}
                            <h3>Warehouse Details</h3>
                            <table
                              style={{ width: "100%", marginBottom: "15px" }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Warehouse Name</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="WarehouseName"
                                      value={formdata.WarehouseName}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Warehouse Address</strong>
                                  </td>
                                  <td colSpan="3">
                                    <input
                                      type="text"
                                      id="WarehouseAddress"
                                      value={formdata.WarehouseAddress}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Client Details */}
                            <h3>Client Details</h3>
                            <table
                              style={{ width: "100%", marginBottom: "15px" }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Client Name</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="ClientName"
                                      value={formdata.ClientName}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <strong>Client Address</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="ClientAddress"
                                      value={formdata.ClientAddress}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Commodity Details */}
                            <table
                              style={{ width: "100%", marginBottom: "15px" }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Name of Commodity</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="NameofCommodity"
                                      value={formdata.NameofCommodity}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <strong>Variety</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="Variety"
                                      value={formdata.Variety}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Main Table */}
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th>CRD No:</th>
                                  <th>No. of Bags</th>
                                  <th>Quantity (MT)</th>
                                  <th>Stack No.</th>
                                  <th>Rate/MT</th>
                                  <th>Packing Quality</th>
                                  <th>Private ID / Mark of Depositor</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <input
                                      type="text"
                                      id="crdNo"
                                      value={formdata.crdNo}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="NoofBags"
                                      value={formdata.NoofBags}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="Quantity"
                                      value={formdata.Quantity}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="Stack"
                                      value={formdata.Stack}
                                      onChange={handleChange}
                                      className="form-control"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="Rate"
                                      value={formdata.Rate}
                                      onChange={handleChange}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="PackingQuality"
                                      value={formdata.PackingQuality}
                                      onChange={handleChange}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <textarea
                                      id="PrivateID"
                                      value={formdata.PrivateID}
                                      onChange={handleChange}
                                      className="form-control"
                                      rows={3}
                                    />
                                  </td>
                                  <td>
                                    <textarea
                                      id="Remarks"
                                      value={formdata.Remarks}
                                      onChange={handleChange}
                                      className="form-control"
                                      rows={3}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>

                        {/* Truck & Net Weight Details */}
                        <h3 style={{ marginTop: "25px" }}>
                          Truck Wise Net Weight
                        </h3>

                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Truck No</th>
                              <th>Net Weight</th>
                              <th>No Of Bags</th>
                            </tr>
                          </thead>
                          <tbody>
                            {trucks.length > 0 ? (
                              trucks.map((row, index) => (
                                <tr key={row.id || index}>
                                  <td>{index + 1}</td>
                                  <td>{row.vehicleNo}</td>
                                  <td>{row.netWt}</td>
                                  <td>{row.noOfBags}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No truck records found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="text-center mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handlePrint}
                        >
                          Print CRD Form
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CRD;

